<div class="rating" data-jest="stars">
  <span *ngFor="let fullStar of fullStars" class="active star" data-jest="full star"></span>
  <span *ngIf="hasAnHalfStar" class="half-active star" data-jest="half star"></span>
  <span *ngFor="let emptyStar of emptyStars" class="star" data-jest="empty star"></span>
</div>
